/**
 * @file 指令统一导出
 */
import emoj from './emoj'
import throttle from './throttle'
import debounce from './debounce'

export default {
    emoj,
    throttle,
    debounce
}

